import { useMutation, UseMutationResult, useQueryClient } from "@tanstack/react-query";
import axios from "axios";
import { useAuthStore } from "../../../../console/store/useAuthStore";
import { enum_api_uri } from "../../utils/enum";

interface OrderCancelRequest {
    order_idx: number[];
    cancel_reason_idx: number;
    cancel_reason: string;
}

export const usePutOrderCancel = (successCallback?: () => void): UseMutationResult<null, Error, OrderCancelRequest, unknown> => {
    const queryClient = useQueryClient();
    const accessToken = useAuthStore(state => state.accessToken);

    return useMutation<null, Error, OrderCancelRequest>({
        mutationFn: async ({ order_idx, cancel_reason_idx, cancel_reason }: OrderCancelRequest) => {
            try {
                const response = await axios.put(
                    `${enum_api_uri.put_order_cancel}`,
                    { order_idx, cancel_reason_idx, cancel_reason },
                    {
                        headers: {
                            Authorization: `Bearer ${accessToken}`,
                        },
                    },
                );
                return response.data.data;
            } catch (error) {
                throw error;
            }
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ["getOrderList"] });
            queryClient.invalidateQueries({ queryKey: ["getOrderHistory"] });
            queryClient.invalidateQueries({ queryKey: ["getOrderInfo"] });
            successCallback?.();
        },
    });
};
